import React, { useState, useCallback, useEffect } from 'react';

import { IoMdTrash } from 'react-icons/io';

import CButton from '../../components/button/button';
import CModal from '../../components/modal/modal';
import AddLegislation from '../../components/forms/add_legislation';
import CSearchBar from '../../components/search-bar/search_bar';
import Tabs from '../../components/vertical-tab/tabs';
import {
  EntryLegislation,
  TypeLegislation,
  types_legislation,
  types_legislation_institution
} from '../../types/menu-legislation';
import styles from './legislation.module.scss';
import {
  addLegislationPrincipal,
  deleteLegislationPrincipal,
  downloadOneLegislationAdmin,
  getAllLegislationAdmin,
  getAllLegislationPrincipal,
  downloadOneLegislationPrincipal
} from '../../network/legislation';
import { notify } from '../../notifications/notification';
import { Space } from '../../components/utils/utils';
import { variables } from '../../utils/variables';

const Legislation = () => {
  const [currOption, setOption] = useState(types_legislation[0]);
  const [filterValue, setValue] = useState('');
  const [list, setList] = useState([]);
  const [listAdmin, setListAdmin] = useState([]);
  const [unfiltered, setUnfiltered] = useState([]);
  const [unfilteredAdmin, setUnfilteredAdmin] = useState([]);
  const [openedModal, setModal] = useState(false);

  useEffect(() => {
    getAllLegislationPrincipal(data => {
      setList(data);
      setUnfiltered(data);
    });
    getAllLegislationAdmin(data => {
      setListAdmin(data);
      setUnfilteredAdmin(data);
    });
  }, []);

  const handleChange = useCallback(
    (value: TypeLegislation) => {
      setOption(value);
    },
    [setOption]
  );

  useEffect(() => {
    setList(
      unfiltered.filter((option: EntryLegislation) =>
        option.name.toUpperCase().includes(filterValue.toUpperCase())
      )
    );
    setListAdmin(
      unfilteredAdmin.filter((option: EntryLegislation) =>
        option.name.toUpperCase().includes(filterValue.toUpperCase())
      )
    );
    // eslint-disable-next-line
  }, [filterValue]);
  useEffect(() => {
    // setList(list.filter(option => option.name.includes(filterValue)));
    // eslint-disable-next-line
  }, [filterValue]);

  const handleFilter = (event: React.ChangeEvent<any>) => {
    const { value } = event.target;
    setValue(value);
  };

  const addNewDoc = () => {
    setModal(!openedModal);
  };

  const deleteDoc = (id: number) => {
    deleteLegislationPrincipal(id, () => {
      notify('Ati sters cu succes o legislatie!', 'success');
      getAllLegislationPrincipal(data => setList(data));
    });
  };

  return (
    <div className={styles.container}>
      <CModal opened={openedModal} openModal={setModal}>
        <AddLegislation
          type={currOption.key}
          submit={addLegislationPrincipal}
          callback={() => {
            setModal(false);
            getAllLegislationPrincipal(data => setList(data));
          }}
        />
      </CModal>
      <Tabs
        options={types_legislation}
        currentOption={currOption}
        onChange={handleChange}
      />
      {types_legislation_institution.find(
        entry => entry.key === currOption.key
      ) && (
        <CButton
          label='Adăugați un document nou'
          onClick={addNewDoc}
          type='button'
          className={styles.add}
        />
      )}
      <div className={styles.content}>
        <CSearchBar value={filterValue} onChange={handleFilter} />
        <p className='body-dark faded'>Legi introduse de platformă</p>
        <Space vertical={variables.verticalSpace} />
        <div className={styles.list}>
          {listAdmin.length > 0 &&
            listAdmin.map(
              (option: EntryLegislation) =>
                option.type === currOption.key && (
                  <div className={styles.set} key={option.id}>
                    <CButton
                      label={`Vizualizați ${option.name}`}
                      type='button'
                      onClick={() =>
                        downloadOneLegislationAdmin(option.id, option.name)
                      }
                    />
                    {/* <CButton
                      label={<IoCloudDownload />}
                      type='button'
                      onClick={() =>
                        downloadOneLegislationAdmin(option.id, option.name)
                      }
                    /> */}
                  </div>
                )
            )}
        </div>
        <p className='body-dark faded'>Legile introduse de dumneavoastră</p>{' '}
        <Space vertical={variables.verticalSpace} />
        <div className={styles.list}>
          {list.length > 0 &&
            list.map(
              (option: EntryLegislation) =>
                option.type === currOption.key && (
                  <div className={styles.set} key={option.id}>
                    <CButton
                      label={`Vizualizați ${option.name}`}
                      type='button'
                      onClick={() =>
                        downloadOneLegislationPrincipal(option.id, option.name)
                      }
                    />
                    <CButton
                      label={<IoMdTrash />}
                      type='button'
                      className={styles.delete}
                      onClick={() => deleteDoc(option.id)}
                    />
                  </div>
                )
            )}
        </div>
      </div>
    </div>
  );
};

export default Legislation;
